import * as React from 'react';
import { useApi } from '../Api/useApi';
import { ChangePasswordRequest, ChangePasswordResponse, UsersRycApiClient } from '../Api/ApiServer';
import DialogBase from '../Shared/DialogBase';
import { Box, Button, Grid2 } from '@mui/material';
import Passwordbox from '../Shared/PasswordBox';
import { delay } from '../Shared/delay';
import { Check } from '@mui/icons-material';
import { useApiWithCallback } from '../Api/useApiWithCallback';

export interface IChangePasswordDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function ChangePasswordDialog(props: Readonly<IChangePasswordDialogProps>) {
  const { open, onClose } = props;
  const [password, setPassword] = React.useState('');
  const [newPassword, setNewPassword] = React.useState('');
  const { authorizedApi } = useApi(UsersRycApiClient);
  const [ok, setOk] = React.useState(false);
  const { callApiWithCallback } = useApiWithCallback();


  // const resetPassword = useCallback(async () => {
  //     callApiWithCallback<AuthResponse>(() => loginApi.authorizedApi.resetPassword(new ResetPasswordRequest({ newPassword: passwordNew })),
  //         (token) => {
  //             if (token?.accessToken && token?.refreshToken)
  //                 login(token.accessToken, token.refreshToken);
  //             setTimeout(() => {
  //                 navigate('/logged/onboardingcheckbox');
  //             }, 3000);
  //         },
  //         t('passwordChanged'))


  // }, [passwordNew, callApiWithCallback, login, loginApi, navigate]);
  const changePassword = React.useCallback(async () => {
    if (!authorizedApi || newPassword === '' || password === '') return;
    callApiWithCallback<ChangePasswordResponse>(() => authorizedApi.changePassword(new ChangePasswordRequest({ newPassword: newPassword, originalPassword: password })),
      async (newPasswordData) => {

        setOk(newPasswordData?.ok ?? false);
        await delay(1300);
        onClose();
        await delay(100);
        setOk(false);
        setPassword('');
        setNewPassword('');
      }, "Heslo bylo změněno");
  }, [authorizedApi, callApiWithCallback, newPassword, password, onClose]);

  return (
    <DialogBase showCloseButton title='Nové heslo'
      dialogActions={<Box m={1} justifyContent='center' display={'flex'} width='100%'>
        <Button disabled={password === '' || newPassword === ''} variant='contained' onClick={changePassword}>Změnit</Button>
      </Box>}
      open={open} onClose={onClose}>
      {!ok && <Grid2>
        <Grid2 mt={2} size={{ xs: 12 }}>
          <Passwordbox autoComplete={'new-password'} sx={{ mb: 2 }} variant='outlined' password={password} onPasswordChange={setPassword} />
        </Grid2>
        <Grid2 size={{ xs: 12 }}>
          <Passwordbox onEnter={changePassword} autoComplete={'new-password'} variant='outlined' password={newPassword} onPasswordChange={setNewPassword} label='Nové heslo' />
        </Grid2>
      </Grid2>}
      {ok && <Box display='flex' justifyContent='center' width='100%'> <Check fontSize='large' color='success' /></Box>}
    </DialogBase>
  );
}
